/**
 * Returns true only for same-origin http(s) URLs, blocking schemes like
 * `javascript:`/`data:` and external/phishing domains before navigation.
 */
export function isSafeUrl(url: string): boolean {
  try {
    const parsed = new URL(url, window.location.origin);
    return (
      parsed.origin === window.location.origin &&
      (parsed.protocol === 'http:' || parsed.protocol === 'https:')
    );
  } catch {
    return false;
  }
}
